export const assistantMessageStyles = {
  root: "flex flex-col",
  bubble: "w-full rounded-2xl bg-muted text-sm leading-relaxed text-foreground",
  bubbleInner: "px-3.5 py-2.5",
  actionBar: "flex items-center gap-1 border-t border-border px-3 py-1.5",
  copyBtn: "rounded p-1 text-subtle hover:bg-muted hover:text-muted-foreground",
  copyBtnFailed: "text-red-400 hover:text-red-400",
  copiedIcon: "text-teal",
};
